import React from "react";
import ModalMarcador from "../modalMarcador";
import { AdvancedMarker } from "@vis.gl/react-google-maps/dist/index.umd.js";



export const TooltipMarcador = ({ marcador, onMouseLeave, onClick }) => {
  const {
    pasto,
    position,
    color,
    url
  } = marcador;

  const showTooltip = pasto && pasto.IdPasto && pasto.Nome;

  if (showTooltip) {
    return (
      <AdvancedMarker
        position={position}
        onClick={onClick}
        id={"tooltip-marcador-" + pasto.IdPasto}
      >
        <ModalMarcador onMouseLeave={onMouseLeave} pasto={pasto} color={color} url={url} />
      </AdvancedMarker>
    );
  }
  return null;

};
